const Timings = () => {
  return (
    <div className="mb-4 mb-sm-5">
       <p className="subTitle text-start fs-5">SCHOOL TIMINGS</p>
        <table>
          <tr>
            <th>School Timings</th>
            <th>Standards</th>
          </tr>
          <tr>
            <td>LKG - 9th Standard</td>
            <td>08.00 AM - 03.45 PM</td>
          </tr>
          <tr>
            <td>10th Standard - 12th Standard</td>
            <td>08.00 AM - 05.30 PM</td>
          </tr>
          <tr>
            <td>School Office</td>
            <td>09.30 AM - 04.30 PM</td>
          </tr>
        </table>
    </div>
  )
}

export default Timings
